import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
  APPLICATIONS_FETCH,
  APPLICATION_FETCH,
  APPLICATIONS_ORDERBY,
  APPLICATIONS_FILTER,
  APPLICATIONS_PAGINATION,
  APPOINTMENTS_FETCH,
  COMMENTS_FETCH,
} from "../constants";

const initialState = {
  application: null,
  applications: [],
  applicationsCount: null,
  applicationsOrderBy: "createdAt",
  applicationsFilter: null,
  applicationsPagination: {
    defaultActivePage: 1,
    totalPages: 1,
    activePage: 1,
  },

  appointments: [],
  appointmentsCount: null,

  comments: [],
  commentsCount: null,
};

const persistConfig = {
  key: "applications",
  storage,
  blacklist: [
    "applicationsFilter",
    "applicationsPagination",
  ],
};

function applicationsReducer(state = initialState, action) {
  switch (action.type) {
    case APPLICATIONS_FETCH:
      return {
        ...state,
        applications: action.result,
        applicationsCount: action.count,
      };

    case APPLICATION_FETCH:
      return { ...state, application: action.result };

    case APPLICATIONS_ORDERBY:
      return { ...state, applicationsOrderBy: action.value };

    case APPLICATIONS_FILTER:
      return { ...state, applicationsFilter: action.value };

    case APPLICATIONS_PAGINATION:
      return { ...state, applicationsPagination: action.value };

    case APPOINTMENTS_FETCH:
      return {
        ...state,
        appointments: action.result,
        appointmentsCount: action.count,
      };

    case COMMENTS_FETCH:
      return {
        ...state,
        comments: action.result,
        commentsCount: action.count,
      };

    default:
      return state;
  }
}

export default persistReducer(persistConfig, applicationsReducer);